import React from 'react';
import f3 from 'family-chart';
import {familyTreeData} from "./familyTreeData";

const MONTH_NAMES_HE = [
    "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
    "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"
];

function formatBirthLine(data, short) {
    const birthday = data.birthday || "";
    const deathYear = data.deathYear;
    const birthDate = data.birthDate;
    let line = birthday;
    if (deathYear) {
        line = `${birthday} - ${deathYear}`;
        return line;
    }
    if (birthDate && birthday) {
        if (short) {
            const month = parseInt(birthDate.split("-")[0], 10);
            line = `${month}/${birthday}`;
        } else {
            const month = parseInt(birthDate.split("-")[0], 10);
            line = `${MONTH_NAMES_HE[month - 1]} ${birthday}`;
        }
    }
    return line;
}

export default class FamilyTree extends React.Component {
    cont = React.createRef();
    
    componentDidMount() {
        const familyTreeDataWithImages = familyTreeData.map((item) => {
            return {
                ...item,
                data: {
                    ...item.data,
                }
            }
        });
        if (!this.cont.current) return;
        const mainId = this.props.initialMemberId || familyTreeDataWithImages[0]?.id;
        const store = f3.createStore({
            data: familyTreeDataWithImages,
            node_separation: 250,
            level_separation: 150,
            main_id: mainId
        })
        const svg = f3.createSvg(document.querySelector("#FamilyChart"))
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            document.querySelector('#FamilyChart').classList.add('mobile');
        }
        const rev = s => [...s].reverse().join('');
        const nameFn = isMobile
            ? i => rev(`${i.data.firstName||""} ${i.data.lastName||""}`)
            : i => `\u200F${i.data.firstName||""} ${i.data.lastName||""}\u200F`;
        const dateFn = isMobile
            ? i => formatBirthLine(i.data, true)
            : i => `\u200F${formatBirthLine(i.data, false)}\u200F`;
        const Card = f3.elements.Card({
            store,
            svg,
            card_dim: {w:220,h:70,text_x:isMobile?75:200,text_y:15,img_w:60,img_h:60,img_x:5,img_y:5},
            card_display: [nameFn, dateFn],
            mini_tree: true,
            link_break: false
        })
        store.setOnUpdate(props => f3.view(store.getTree(), svg, Card, Object.assign({transition_time: 1000}, props || {})))
        store.updateTree({initial: true})
    }

    render() {
        return <div className="f3" id="FamilyChart" ref={this.cont}></div>;
    }
}